import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconAccount = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconAccount.dimensions.width} ${IconAccount.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M9 9.497a4.504 4.504 0 0 1-4.5-4.5A4.504 4.504 0 0 1 9 .5c2.48 0 4.5 2.018 4.5 4.5S11.482 9.5 9 9.5v-.003Zm0-8.209A3.716 3.716 0 0 0 5.288 5 3.716 3.716 0 0 0 9 8.712 3.716 3.716 0 0 0 12.712 5 3.716 3.716 0 0 0 9 1.288Zm6.688 16.206-.006-.108c-.133-2.166-1.354-4.111-3.268-5.203a6.843 6.843 0 0 0-3.393-.901 6.91 6.91 0 0 0-1.684.207c-1.737.43-3.194 1.487-4.103 2.972a6.3 6.3 0 0 0-.913 2.928l-.006.108H1.5l.006-.12a7.076 7.076 0 0 1 1.024-3.314c1.022-1.667 2.655-2.852 4.6-3.333a7.86 7.86 0 0 1 1.888-.23c1.333 0 2.649.35 3.808 1.012 2.158 1.234 3.53 3.426 3.668 5.869l.006.119h-.815l.003-.006Z"
      />
    </Svg>
  )
}

IconAccount.dimensions = {
  width: 24,
  height: 24,
}

export default IconAccount
